module.exports = __webpack_public_path__ + "img/policy-yuri.266f797d.webp";